import { render } from "./table.vue?vue&type=template&id=220b178e&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"

import "./table.vue?vue&type=style&index=0&id=220b178e&lang=css"
import "./table.vue?vue&type=style&index=1&id=220b178e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220b178e"]])

export default __exports__